import { GlobulesAGogo } from './../globulesagogo/GlobulesAGogo';
import { Trampopeau } from '../trampopeau/Trampopeau';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from './GameAbstract';
import Context from 'frontools/core/Context';
import GamesState from './state/GamesState';
import { autobind } from 'frontools/decorators/Autobind';
import Breakpoint from 'frontools/core/Breakpoint';

import { Crocroc } from '../crocroc/Crocroc';
import { Becquerbobo } from '../becquerbobo/Becquerbobo';
import { Cosmocostaud } from '../cosmocostaud/Cosmocostaud';
import { Poussepython } from '../poussepython/Poussepython';
import { Attrapegrippette } from "../attrapegripette/Attrapegrippette";
import { Bastasiesta } from '../bastasiesta/Bastasiesta';
import { Titubetibia } from '../titubetibia/Titubetibia';
import { Cavalefringale } from '../cavalefringale/Cavalefringale';


export class GameManager extends AbstractDispatcher {

    private static _instance        : GameManager;
    private _gameList               : any                           = { 
        crocroc: Crocroc,
        trampopeau: Trampopeau,
        cosmocostaud: Cosmocostaud,
        becquerbobo: Becquerbobo,
        poussepython: Poussepython,
        attrapegrippette: Attrapegrippette,
        bastasiesta: Bastasiesta,
        globulesagogo: GlobulesAGogo,
        titubetibia: Titubetibia,
        cavalefringale: Cavalefringale
    };
    private _context                : Context                       = Context.getInstance();
    private _game                   : GameAbstract;
    private _name                   : string;

    constructor() {
        
        super();

        new GamesState();

        if (GameManager._instance) throw new Error('Error: Use GameManager.getInstance() instead of new.');
        GameManager._instance = this;

        var directory = this._context.getURL().uri.directory;
        this._name = directory.substr(1, directory.length).split('/')[0];

        if (typeof this._gameList[this._name] !== 'undefined') {
            GamesState.key = this._name;
            this._initNextPanel();
            let data = JSON.parse(this._context.getValue('gameData')).next;
            if (data) {
                this._gameList[this._name].next = data.url;
            }
            this._game = new this._gameList[this._name]() as GameAbstract;
        }

        window.addEventListener('orientationchange', this._onOrientationChange);
        this._onOrientationChange();

        var tutorialImage = document.querySelector('img.tutorial') as HTMLImageElement;                  
        if (tutorialImage) tutorialImage.src = (Context.getInstance().isTouch()) ? tutorialImage.getAttribute('data-src-2x') : tutorialImage.getAttribute('data-src');
    }


    private _initNextPanel() {
        let data = JSON.parse(this._context.getValue('gameData')).next,
            panelList = document.querySelector('.panel_list') as HTMLElement,
            panelNext = document.querySelector('.panel_next') as HTMLElement;

        TweenMax.fromTo(panelList, .5, {alpha: 0, y: -20}, {y: 0, alpha: 1, ease: Expo.easeOut});

        if (data) {
            let panels = document.querySelectorAll('.panel'),
                teaser = document.querySelector('[data-js="nextGameTeaser"]') as HTMLElement,
                link = document.querySelector('[data-js="nextGameLink"]') as HTMLElement;

            teaser.innerHTML = data.text;
            link.setAttribute('href', data.url);
            TweenMax.fromTo(panelNext, .5, {delay: .1, alpha: 0, y: -20}, {y: 0, alpha: 1, ease: Expo.easeOut});
        } else {
            panelNext.style.visibility = 'hidden';
        }
    }


    public getNextGame(current: string) {
        return this._gameList[current].next || null;
    };

    /**
     * getGameName - Return currently played game name
     * 
     */
    public getName(): string {
        return this._name;
    };


    @autobind
    private _onOrientationChange() {
        // trigger resize on window
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent('resize', true, false);
        window.dispatchEvent(evt);
    };


    /**
     * get singleton instance
     * @returns {GameManager}  instance's ClassName
     */
    public static getInstance(): GameManager {
        if (GameManager._instance) {
            return GameManager._instance;
        } else {
            throw new Error('Error: GameManager instance hasn’t been created yet');
        }
    }

}


export class GameMode {
    public static TITLE                 : string                        = 'intro';
    public static COUNTDOWN             : string                        = 'countdown';
    public static PLAYING               : string                        = 'playing';
    public static RESULT                : string                        = 'result';
    public static END                   : string                        = 'end';
}